import Vue from 'vue'
import _this from "../main.js";
import Router from 'vue-router'
import Store from "../store";
import ApiService from '../service/http.js'
import VueSocketIO from 'vue-socket.io'
import io from "socket.io-client";
import '../assets/css/ediElementStyle.css'
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};

const originalReplace = Router.prototype.replace;
Router.prototype.push = function push(location) {
  return originalReplace.call(this, location).catch((err) => err);
};


Vue.use(Router)
let routes = [
  {
    path: "/",
    redirect: "/index",
  },
  {
    path: '/index',
    component: () => import('/src/views/index/index.vue'),
    meta: {
      title: '首页',
    }
  },
  {
    path: '/home',
    meta: {
      title: '桥梁检测业务系统'
    },
    component: () => import('/src/views/home1'),
    children: [
      // 桥梁管理
      {
        path: '/bridgeList',
        component: () => import('/src/views/bridgeManagement/bridgeList.vue'),
        meta: {
          title: '桥梁登记',
          parentTitle: '桥梁管理'
        }
      },
      {
        path: '/bridgeTypeList',
        component: () => import('/src/views/bridgeManagement/bridgeTypeList.vue'),
        meta: {
          title: '桥梁类型列表',
          parentTitle: '基础管理'
        }
      },
      // 任务管理
      {
        path: '/taskList',
        component: () => import('/src/views/taskManagement/taskList.vue'),
        meta: {
          title: '任务登记',
          parentTitle: '任务管理'
        }
      },
      // 项目管理
      {
        path: '/subjectList',
        component: () => import('/src/views/subjectManagement/subjectList.vue'),
        meta: {
          title: '项目登记',
          parentTitle: '项目管理'
        }
      },
      // 定检管理
      {
        path: '/inspectionList',
        component: () => import('/src/views/inspectionManagement/inspectionList.vue'),
        meta: {
          title: '检测列表',
          parentTitle: '定检管理'
        }
      },
      // 特殊检测列表
      {
        path: '/specialInspectionList',
        component: () => import('/src/views/inspectionManagement/specialInspectionList.vue'),
        meta: {
          title: '特殊检测列表',
          parentTitle: '定检管理'
        }
      },
      // 巡检管理
      {
        path: '/routingInspectionList',
        component: () => import('/src/views/inspectionManagement/routingInspectionList.vue'),
        meta: {
          title: '巡检列表',
          parentTitle: '巡检管理'
        }
      },
      // 数据统计
      {
        path: '/diseaseStatistics',
        component: () => import('/src/views/statisticsManagement/diseaseStatisticsList.vue'),
        meta: {
          title: '数据统计',
          parentTitle: '病害统计'
        }
      },
    ]
  },
  {
    path: '/componentDetail',
    component: () => import('/src/views/bridgeManagement/componentDetail.vue'),
    meta: {
      title: '部件库',
    }
  },
  {
    path: '/diseaseDetail',
    component: () => import('/src/views/bridgeManagement/diseaseDetail.vue'),
    meta: {
      title: '病害库',
    }
  },
  {
    path: '/customComponentDetail',
    component: () => import('/src/views/bridgeManagement/customComponentDetail.vue'),
    meta: {
      title: '自定义部件库',
    }
  },
  {
    path: '/customDiseaseDetail',
    component: () => import('/src/views/bridgeManagement/customDiseaseDetail.vue'),
    meta: {
      title: '自定义病害库',
    }
  },
  {
    path: '/inspectionDetailList',
    component: () => import('/src/views/inspectionManagement/inspectionDetailList.vue'),
    meta: {
      title: '检测记录详情列表',
    }
  },
  {
    path: '/specialInspectionDetailList',
    component: () => import('/src/views/inspectionManagement/specialInspectionDetailList.vue'),
    meta: {
      title: '特殊检测记录详情列表',
    }
  },
  {
    path: '/routingInspectionDetailList',
    component: () => import('/src/views/inspectionManagement/routingInspectionDetailList.vue'),
    meta: {
      title: '巡检记录详情列表',
    }
  },
  {
    path: '/projectApprovalDetail',
    component: () => import('/src/views/taskManagement/taskDetail.vue'),
    meta: {
      title: '桥信息',
    }
  },
  {
    path: "/login",
    component: () => import("/src/views/Login/login"),
    meta: {
      title: "登录",
      needLogin: false,
    },
  },
];
const router = new Router({
  mode: 'history',
  base: '/system',
  routes,
})
let apiArr = [
  // 桥梁管理
  {
    permission: '/bridgeManagement',
    menuName: '桥梁管理',
    meta: {
      title: '桥梁管理',
    },
    children: [
      {
        permission: '/bridgeList',
        menuName: '桥梁登记',
        children: [],
        component: () => import('/src/views/bridgeManagement/bridgeList.vue'),
        meta: {
          title: '桥梁登记',
          parentTitle: '桥梁管理'
        }
      },
    ]
  },
  // 基础管理
  {
    permission: '/baseManagement',
    menuName: '基础管理',
    meta: {
      title: '基础管理',
    },
    children: [
      {
        permission: '/bridgeTypeList',
        menuName: '桥梁类型列表',
        children: [],
        component: () => import('/src/views/bridgeManagement/bridgeTypeList.vue'),
        meta: {
          title: '桥梁类型列表',
          parentTitle: '基础管理'
        }
      },
    ]
  },
  // 任务管理
  {
    permission: '/taskManagement',
    menuName: '任务管理',
    meta: {
      title: '任务管理',
    },
    children: [
      {
        permission: '/taskList',
        menuName: '任务登记',
        children: [],
        component: () => import('/src/views/taskManagement/taskList.vue'),
        meta: {
          title: '任务登记',
          parentTitle: '任务管理'
        }
      },
    ]
  },
  // 项目管理
  {
    permission: '/subjectManagement',
    menuName: '项目管理',
    meta: {
      title: '项目管理',
    },
    children: [
      {
        permission: '/subjectList',
        menuName: '项目登记',
        children: [],
        component: () => import('/src/views/subjectManagement/subjectList.vue'),
        meta: {
          title: '项目登记',
          parentTitle: '项目管理'
        }
      },
    ]
  },
  // 检测管理
  {
    permission: '/inspectionManagement',
    menuName: '定检管理',
    meta: {
      title: '定检管理',
    },
    children: [
      {
        permission: '/inspectionList',
        menuName: '检测列表',
        children: [],
        component: () => import('/src/views/inspectionManagement/inspectionList.vue'),
        meta: {
          title: '检测列表',
          parentTitle: '定检管理'
        }
      },
      {
        permission: '/specialInspectionList',
        menuName: '特殊检测列表',
        children: [],
        component: () => import('/src/views/inspectionManagement/specialInspectionList.vue'),
        meta: {
          title: '特殊检测列表',
          parentTitle: '检测管理'
        }
      },
    ]
  },
  // 巡检管理
  {
    permission: '/routingInspectionManagement',
    menuName: '巡检管理',
    meta: {
      title: '巡检管理',
    },
    children: [
      {
        permission: '/routingInspectionList',
        menuName: '巡检列表',
        children: [],
        component: () => import('/src/views/inspectionManagement/routingInspectionList.vue'),
        meta: {
          title: '巡检列表',
          parentTitle: '巡检管理'
        }
      },
    ]
  },
]

router.beforeEach((to, from, next) => {
  window.document.title = to.meta.title
  if (to.path === '/login' || to.path === '/index') { //不需要登录
    next()
  } else {
    if (Store.state.authorization) { //已经登录
      let fn = new ApiService()
      fn.getUserPermission({}, "post").then(res => {
        if (res.code === '0') {
          if (res.body && res.body.data && res.body.data.userVo && res.body.data.userVo.userType) { //公司及公司账号
            _this.$store.commit("setUserInfo", res.body.data.userVo);
            if (res.body && res.body.data && res.body.data.menus && res.body.data.menus.length > 0) { //权限菜单
              _this.$store.commit("setSidebarList", res.body.data.menus);
              next();
            } else {
              _this.$alert('对不起，您还没有桥梁检测系统的菜单权限，无法访问', '提示', {
                confirmButtonText: '确定',
                showClose: false,
                callback: action => {
                  _this.$store.commit("deleteAllMenuList");
                  next({
                    path: '/login'
                  });
                }
              });
            }
          } else {
            _this.$alert('对不起，您不是该公司员工，无法访问', '提示', {
              confirmButtonText: '确定',
              showClose: false,
              callback: action => {
                _this.$store.commit("deleteAllMenuList");
                next({
                  path: '/login'
                });
              }
            });
          }
        }
      })
    } else {
      next({
        path: '/login'
      });
    }
  }
});
export default router;
